import axios from "axios";
import {
  getAuthCookies,
  setAuthCookies,
} from "../auth-cookies/auth-cookies.service";
import { getAuthConfig } from "../auth-config/auth-config.service";
import type {
  TRenewTokenResponse,
  TRenewTokenApiResponse,
} from "../auth-http-client/auth-http-client.types";

const normalizeBaseUrl = (url: string): string => {
  return url.endsWith("/") ? url : `${url}/`;
};

const callRenewApi = async (
  refreshToken: string,
): Promise<TRenewTokenResponse> => {
  const config = getAuthConfig();
  const baseUrl = normalizeBaseUrl(config.apiUrl);

  const response = await axios.post<
    TRenewTokenApiResponse | TRenewTokenResponse
  >(`${baseUrl}v2/login/renewtoken`, { refreshToken });

  const data = response.data;
  if ("Data" in data && data.Data) {
    return data.Data;
  }
  return data as TRenewTokenResponse;
};

let inflightRefresh: Promise<string> | null = null;

export const refreshAuthTokens = async (): Promise<string> => {
  if (inflightRefresh) return inflightRefresh;

  inflightRefresh = (async () => {
    const cookies = getAuthCookies();
    if (!cookies.refreshToken) {
      throw new Error("No refresh token available");
    }

    const tokens = await callRenewApi(cookies.refreshToken);

    setAuthCookies({
      idToken: tokens.IdToken,
      refreshToken: tokens.RefreshToken,
      accessToken: tokens.AccessToken,
      userHash: cookies.userHash || "",
    });

    return tokens.IdToken;
  })();

  try {
    return await inflightRefresh;
  } finally {
    inflightRefresh = null;
  }
};
